import React, { Component, Fragment } from "react";
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  FormControl,
} from "@material-ui/core";
import {
  extractCheckBoxIndices,
  extractAiFlags,
} from "../../store/form.answer.extract";
import { checkBoxAnswer } from "../../store/form.answer.fill";
import { openSectionState, currentSectionState } from "../../store/form.store";
import { AiStatusOverlay } from "../../../components/AiStatusOverlay";

export class CheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: [],
      selectedOptionIndices: [],
      // helpTextValue: "",
      imageValue: [],
      editable: false,
      aiFlags: {},
    };
  }

  componentDidMount() {
    let expanded = "";
    this.sectionStateSubscription = openSectionState.subscribe((sectionId) => {
      expanded = sectionId;
    });
    this.currentSectionSubscription = currentSectionState.subscribe(
      (section) => {
        this.setState({ editable: section === expanded });
      },
    );
    this.onLoadPage(this.props);
    // if (this.props.element.properties.answerLabel) {
    //   this.onLoadHelpText(this.props);
    // }
    if (this.props.element.properties.allowFileUpload) {
      this.onLoadImage(this.props);
    }
  }

  componentWillUnmount() {
    this.sectionStateSubscription.unsubscribe();
    this.currentSectionSubscription.unsubscribe();
  }

  componentDidUpdate(prevProps) {
    const prevAnswer = prevProps?.element?.answer;
    const currentAnswer = this.props?.element?.answer;
    const prevOptions = prevProps?.element?.options;
    const currentOptions = this.props?.element?.options;

    if (prevAnswer !== currentAnswer || prevOptions !== currentOptions) {
      this.onLoadPage(this.props);
      if (this.props?.element?.properties?.allowFileUpload) {
        this.onLoadImage(this.props);
      }
    }
  }

  onLoadPage(props) {
    if (props.element) {
      let answer = props.element.answer;
      const selectedIndices = extractCheckBoxIndices(
        answer,
        props.element.options,
      ) || [];
      const uniqueIndices = [...new Set(selectedIndices)];
      const userResponse = uniqueIndices
        .map((index) => props?.element?.options?.[index])
        .filter((value) => value !== undefined && value !== null && value !== "");

      this.setState({
        selectedOptions: userResponse,
        selectedOptionIndices: uniqueIndices,
      });
    }
  }

  // onLoadHelpText(props) {
  //   const answerLabel = props.element.properties.answerLabel;
  //   if (answerLabel) {
  //     this.setState({ helpTextValue: answerLabel });
  //   }
  // }

  onLoadImage(props) {
    let aiFlags = {};
    if (
      props.element &&
      props.element.answer &&
      props.element.answer.length > 0
    ) {
      const image = props.element.answer[0].images;
      if (image) {
        this.setState({ imageValue: image });
      }
      aiFlags = extractAiFlags(props.element.answer) || {};
    }
    this.setState({ aiFlags });
  }

  onChange = (option, selectedOptionIndex) => {
    const selectedIndices = [...this.state.selectedOptionIndices];
    const selectedIndexSet = new Set(selectedIndices);

    if (!selectedIndexSet.has(selectedOptionIndex)) {
      selectedIndexSet.add(selectedOptionIndex);
    } else {
      selectedIndexSet.delete(selectedOptionIndex);
    }

    const nextSelectedIndices = [...selectedIndexSet].sort((a, b) => a - b);
    const options = nextSelectedIndices
      .map((index) => this.props?.element?.options?.[index])
      .filter((value) => value !== undefined && value !== null && value !== "");

    this.setState(
      {
        selectedOptions: options,
        selectedOptionIndices: nextSelectedIndices,
      },
      () => {
      if (this.props.onChange !== undefined) {
        this.props.onChange(
          checkBoxAnswer(options, this.props?.element?.answer),
          this.props.element
        );
      }
      },
    );
  };

  render() {
    const { selectedOptionIndices } = this.state;
    return (
      <Fragment>
        {this.state.editable ? (
          <FormControl component="fieldset">
            <FormGroup>
              {this.props.element.options.map((option, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        key={index}
                        name={option}
                        value={`${index}`}
                        onChange={() => {
                          this.onChange(option, index);
                        }}
                        checked={
                          selectedOptionIndices &&
                          !selectedOptionIndices.includes(index)
                            ? false
                            : true
                        }
                      />
                    }
                    label={option}
                  />
                );
              })}
            </FormGroup>
          </FormControl>
        ) : (
          <>
            {this.state.selectedOptions.map((option, index) => (
              <Typography key={`${option}-${index}`}>{option}</Typography>
            ))}
          </>
        )}
        {/* {this?.state?.helpTextValue && (
          <FormHelperText>{this.state.helpTextValue}</FormHelperText>
        )} */}
        {this.props.element.properties.allowFileUpload &&
        this.state.imageValue.length ? (
          <AiStatusOverlay
            imageList={this.state.imageValue}
            aiVerificationStatus={this.state.aiFlags?.aiVerificationStatus}
            aiVerificationMessage={this.state.aiFlags?.aiVerificationMessage}
          />
        ) : null}
      </Fragment>
    );
  }
}
export default CheckBox;
